export default __webpack_public_path__ + "static/media/statistics-graph-img.1a5bf6a7.png";